<template>
  <AppModal id="pre-import-language" :close-on-backdrop="closeOnBackdrop">

    <template #title>
      <h3 class="text-center mb-5">{{$t($getConst.pages.language.import_language_title) | capitalize}} : {{ languageCode
        }}</h3>
    </template>

    <template #content>
      <div class="mx-auto text-center">
        <input
          type="file"
          name="file"
          id="file"
          class="input-file"
          :disabled="isLoading"
          @change="onImportLanguageFile"
          accept="application/json"
        />
        <label for="file">
          <i :class="[$getConst.icons.upload, 'mr-2']"/>
          <span v-if="!file">{{$t($getConst.pages.form.choose_file)}}</span>
          <span v-else>{{file.name}}</span>
        </label>
      </div>

      <b-progress v-if="isLoading" class="mx-auto w-75" show-progress animated variant="secondary" height="3rem">
        <b-progress-bar class="font-weight-bold font-size-md" :value="uploadPercentage"
                        :label="`${uploadPercentage}%`"/>
      </b-progress>
    </template>

    <template v-if="isUploadSucceed" #button>
      <AppConfirmButtons
        :submit-text="$t($getConst.pages.language.import_language_button)"
        :is-loading="isLoading"
        @onSubmit="submit"
        @onCancel="closeModal"
      />
    </template>
  </AppModal>

</template>

<script>
  import AppModal from "../../components/common/modals/AppModal";
  import AppConfirmButtons from "../../components/common/utils/AppConfirmButtons";
  import {importLanguage} from "../../api/languages.api";
  import {getOneLanguageDictionary} from "../../shared/locales/i18n";

  export default {
    name: "importLanguageModal",
    components: {AppConfirmButtons, AppModal},
    props: ['languageCode'],
    data() {
      return {
        file: null,
        uploadPercentage: 0,
        isLoading: false,
        isUploadSucceed: false,
        closeOnBackdrop: true
      }
    },
    methods: {
      onImportLanguageFile(event) {
        this.file = event.target.files[0];
        this.isUploadSucceed = true;
      },
      closeModal() {
        this.$bvModal.hide("pre-import-language");
      },
      submit() {
        this.isLoading = true;
        this.uploadPercentage = 0;
        importLanguage(
          this.languageCode,
          this.file,
          (event) => {
            this.uploadPercentage = Math.round(100 * event.loaded / event.total);
          }
        ).then(() => {
          this.uploadPercentage = 0;
          this.isLoading = false;
          this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
          getOneLanguageDictionary(this.languageCode);
          this.closeModal();
        }).catch((error) => {
          this.uploadPercentage = 0;
          this.isLoading = false;
          if (error.response.data.code === 422) {
            if (error.response.data.error.file[0] === "validation.mimes") {
              this.$snotify.error(this.$t(this.$getConst.pages.alerts.file_not_supported));
            }
          }
          this.handleApiError(error);
        });
      }
    },
    mounted() {
      this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
        if (modalId === "pre-import-language") {
          this.file = null;
          this.isUploadSucceed = false;
          this.uploadPercentage = 0;
        }
      })
    }
  }
</script>

<style scoped>

</style>
